<template>
    <div class="muven-container">
        <div class="muven-router-name-container">
            <p class="muven-router-name">Lojas</p>
        </div>

        <div class="muven-content">
            <!-- As lojas vêm da retaguarda: a tela é só consulta, e precisa dizer isso e onde alterar. -->
            <div class="store-source-notice">
                <AuditActorTileCmp kind="backend" :size="34" />

                <div class="store-source-text">
                    <p class="store-source-title">
                        Lojas sincronizadas da retaguarda<template v-if="backendName"> {{backendName}}</template>
                        <span class="store-source-readonly">
                            <fa icon="lock" />
                            Somente leitura
                        </span>
                    </p>

                    <p class="store-source-description">
                        Nome, CNPJ e status são mantidos na retaguarda. Para cadastrar, alterar ou inativar
                        uma loja, faça a mudança {{backendName ? `no ${backendName}` : 'por lá'}}: ela chega
                        ao Muven pela integração.
                    </p>
                </div>
            </div>

            <div class="table-responsive">
                <table class="table table-sm table-striped">
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Id retaguarda</th>
                            <th>CNPJ</th>
                            <th class="status-col">Status</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(store, index) in storeList" :key="index">
                            <td>{{store.name}}</td>
                            <td>{{store.idSource}}</td>
                            <td>{{store.document}}</td>
                            <td>
                                <span v-if="store.isActive">
                                    <span class="muven-td-icon">
                                        <fa icon="check-circle"
                                            class="text-success" />
                                    </span>

                                    <span>Ativo</span>
                                </span>

                                <span v-if="!store.isActive">
                                    <span class="muven-td-icon">
                                        <fa icon="ban"
                                            class="text-muted" />
                                    </span>

                                    <span>Inativo</span>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <ListCount :amount="storeList.length" />
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import {infoOrPlaceholder} from '@/utils/filters/InformationOrPlaceholderFilter'
import AuditActorTileCmp from '@/audit/components/AuditActorTileCmp.vue'

export default {
    name: 'StoreListView',
    components: {
        AuditActorTileCmp,
    },
    filters: {
        infoOrPlaceholder,
    },
    computed: {
        ...mapState({
            storeList: state => state.storeList,
            subscriber: state => state.subscriber,
        }),
        backendName() {
            return (this.subscriber && this.subscriber.getBackendName && this.subscriber.getBackendName()) || ''
        },
    },
}
</script>

<style lang="scss" scoped>
// Mesmo tile e tom grafite da retaguarda na auditoria: a origem é reconhecida pela identidade.
.store-source-notice {
    display: flex;
    align-items: flex-start;
    gap: 14px;
    margin-bottom: 20px;
    padding: 14px 18px;
    background-color: var(--surface-2);
    border: 1px solid var(--border);
    border-left: 3px solid var(--text);
    border-radius: 4px;
}

.store-source-text {
    min-width: 0;

    p {
        margin-bottom: 0;
    }
}

.store-source-title {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px 10px;
    font-weight: 600;
    color: var(--text);
}

.store-source-readonly {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 1px 8px;
    font-size: .75em;
    font-weight: 700;
    letter-spacing: .5px;
    text-transform: uppercase;
    color: var(--text-muted);
    background-color: var(--border);
    border-radius: 10px;
}

.store-source-description {
    margin-top: 3px;
    font-size: .92em;
    color: var(--text-muted);
}
</style>
